import ControlPanel from "../components/ControlPanel/ControlPanel"

const ControlPanelView = ({mode}) => {
    return <ControlPanel mode={mode}/>
}

export default ControlPanelView